/**
 * @module interface
 */
export interface V2TimGroupMemberChangeInfo {
    userID?: string;
    muteTime?: number;
}
